import { removeURLParam } from 'utility/Provide/Url';

import { SearchParam } from 'types/Search/params';

import {
    ActiveFilter,
    FilterAction,
    FilterAction_Type,
} from 'proto/Search/ActiveFilter';

const removeValueFromList = (list: string, value: string): string =>
    list
        .split(',')
        .filter((e) => e !== value)
        .join(',');

const removeListParam = (
    searchParams: URLSearchParams,
    paramName: string,
    paramValue: string
) => {
    if (searchParams.has(paramName)) {
        const currentListValue = searchParams.get(paramName);
        if (currentListValue) {
            searchParams.set(
                paramName,
                removeValueFromList(currentListValue, paramValue)
            );
        }
    }

    return searchParams;
};

export const mergeFilterActionList = (
    activeFilterList: ActiveFilter[]
): FilterAction[] =>
    activeFilterList.reduce<FilterAction[]>(
        (mergedList, activeFilter) => [
            ...mergedList,
            ...activeFilter.actionList,
        ],
        []
    );

export const getFilterResetData = (filterActionList: FilterAction[]) => {
    let currentSearchParams = new URLSearchParams(window.location.search);
    const paramsToSet: string[] = [];
    const paramListValueListToSet: Record<string, string[]> = {};
    const listParams: Record<string, string[]> = {};
    const regionActions = filterActionList.filter(
        (action) => action.parameter === SearchParam.AreaId
    );

    if (regionActions.length > 0) {
        let tempParams = new URLSearchParams(currentSearchParams.toString());

        regionActions.forEach((action) => {
            if (action.type === FilterAction_Type.RemoveParam) {
                tempParams = removeURLParam(tempParams, action.parameter);
            } else if (action.type === FilterAction_Type.RemoveListValue) {
                tempParams = removeListParam(
                    tempParams,
                    action.parameter,
                    action.value
                );
            }
        });

        const remainingRegions = tempParams.get(SearchParam.AreaId);
        if (!remainingRegions || remainingRegions.trim() === '') {
            currentSearchParams = removeURLParam(
                currentSearchParams,
                SearchParam.CityId
            );
            paramsToSet.push(SearchParam.CityId);
        }
    }

    filterActionList.forEach((filterAction) => {
        if (filterAction.type === FilterAction_Type.RemoveParam) {
            currentSearchParams = removeURLParam(
                currentSearchParams,
                filterAction.parameter
            );
            paramsToSet.push(filterAction.parameter);
        } else if (filterAction.type === FilterAction_Type.RemoveListValue) {
            currentSearchParams = removeListParam(
                currentSearchParams,
                filterAction.parameter,
                filterAction.value
            );
            if (!listParams[filterAction.parameter]) {
                listParams[filterAction.parameter] = [];
            }
            listParams[filterAction.parameter].push(filterAction.value);
        }
    });

    for (const key in listParams) {
        if (!paramListValueListToSet[key]) {
            paramListValueListToSet[key] = [];
        }
        const currentValueInSearch = currentSearchParams.get(key);
        if (currentValueInSearch) {
            paramListValueListToSet[key] = currentValueInSearch
                .split(',')
                .filter((x) => listParams[key].indexOf(x) < 0);
        }
    }

    return {
        paramsToSet: paramsToSet,
        paramListValueListToSet: paramListValueListToSet,
        currentSearchParams: currentSearchParams,
    };
};
